import { Component, Input, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { HisAuthService, HisBaseGlobalsService } from 'hisng';

import { DocumentMetadata } from 'app/fs/res/common/model/documents/documentMetadata';
import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { OrganizationPatent } from 'app/fs/res/patent/model/patent/patent-classes';
import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-edit-basic-data-tab',
    templateUrl: './patent-edit-basic-data-tab.component.html',
    providers: [ProviderManager.getComponentProvider(PatentEditBasicDataTabComponent)],
} )
export class PatentEditBasicDataTabComponent {
    @Input() patent: Patent;
    @Input() documentsToSave: DocumentMetadata[];
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    inventorsModel: any;

    constructor(
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService ) {
    }

    /* implementation handle organizations changed */
    public organizationsChange( event: OrganizationPatent[] ): void {
        this.patent.organizations = [...event];
    }

    public isPriority(): boolean {
        return this.patent.priorityPatent == null ? true : false;
    }

}
